module.exports = __webpack_public_path__ + "237255561ffc7aa61bde62608b303efe.png";